module.exports = __webpack_public_path__ + "img/onclick.673f4157.png";